import { useState } from "react";
import { AlfredInitiateDepositTransaction, CreateSessionResponse } from "src/api";

export interface DepositState {
  // Amount state
  amount: string;
  amountTouched: boolean;

  // Loading and error state
  initiateDepositLoading: boolean;
  initiateDepositError: string | null;

  // Session state
  sessionData: CreateSessionResponse | null;

  // Bank-deposit instructions returned by Alfred /onramp for inline rails
  paymentInstructions: AlfredInitiateDepositTransaction | null;
}

export const useDepositState = () => {
  // Amount state
  const [amount, setAmount] = useState<string>("");
  const [amountTouched, setAmountTouched] = useState(false);

  // Loading and error state
  const [initiateDepositLoading, setInitiateDepositLoading] = useState(false);
  const [initiateDepositError, setInitiateDepositError] = useState<string | null>(null);

  // Session state
  const [sessionData, setSessionData] = useState<CreateSessionResponse | null>(null);

  // SPEI/PIX/COELSA/ACH bank instructions returned inline by Alfred
  const [paymentInstructions, setPaymentInstructions] = useState<AlfredInitiateDepositTransaction | null>(null);

  // Country-specific bank id input (today only Colombia / COP needs
  // it). Stored as a free-text string; format validation lives in the
  // form. We keep it on the deposit state so a re-render of the
  // amount input doesn't reset the user's typed code.
  const [bankId, setBankId] = useState<string>("");

  return {
    // Amount state
    amount,
    setAmount,
    amountTouched,
    setAmountTouched,

    // Loading and error state
    initiateDepositLoading,
    setInitiateDepositLoading,
    initiateDepositError,
    setInitiateDepositError,

    // Session state
    sessionData,
    setSessionData,

    // Inline payment instructions
    paymentInstructions,
    setPaymentInstructions,

    // CO-only bank id input
    bankId,
    setBankId,
  };
};
